export default __webpack_public_path__ + "static/media/hero-woman-wcontent-area@3x.f2444ee3.png";